import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../appStore";
import { EAppReducers } from "../../white-list";

const getState = (state: RootState) => state[EAppReducers.BREADCRUMBS];

export const breadcrumbSelector = createSelector(getState, (state) => state);
